import { UnstyledButton } from '@faceup/ui'
import type { ReactNode } from 'react'
import { useRedaction } from './RedactionProvider'
import type { RedactTextType } from './redactionConstants'
import { getTextByTextType } from './redactText'
import { TextToRedact } from './TextToRedact'

type UsernameRedactProps = {
  children: ReactNode
  type: RedactTextType
  text: string
}

export const UsernameRedact = (props: UsernameRedactProps) => {
  const { children, type, text: originalText } = props
  const { isRedactionActive, texts, redactText } = useRedaction()

  if (!isRedactionActive) {
    return <>{children}</>
  }

  if (type.type === 'sender') {
    return (
      <TextToRedact type={type} text={originalText}>
        {originalText}
      </TextToRedact>
    )
  }

  const redactedText = getTextByTextType(texts, type)
  const text = redactedText ?? originalText
  const shownName = text === originalText ? text : `User ${text}`

  return (
    <UnstyledButton
      className='font-semibold'
      onClick={() => {
        redactText(
          type,
          {
            start: 0,
            end: text.length,
            variant: redactedText === undefined ? 'redacted' : 'notRedacted',
          },
          originalText
        )
      }}
    >
      {shownName}
    </UnstyledButton>
  )
}
